class UpdateUserImageAndVideoReq{
    constructor(){
        this.ProfileImage = null;
        this.ProfileVideo = null;
        this.UserId = null;
    }
}
export default UpdateUserImageAndVideoReq;